/**
 * Спрайт иконок. Перенесён из макета без правок: иконки кита рисуются
 * обводкой, а толщина, скругления и размер заданы в CSS (`.ni svg`),
 * поэтому у самих символов оформления нет.
 *
 * Вставляется один раз в корне приложения, используется через
 * <svg><use href="#i-cal" /></svg> — ровно как в макете.
 */
export function IconSprite() {
  return (
    <svg style={{ display: 'none' }} aria-hidden="true">
    <symbol id="ic-coin" viewBox="0 0 20 20">
    <circle cx="10" cy="10" r="8.5" fill="var(--coin)"/>
    <circle cx="10" cy="10" r="6.6" fill="none" stroke="var(--coin-line)" strokeWidth="1" opacity=".55"/>
    {/* знак студии: буква A и штрих под ней, как в логотипе */}
    <path d="M7.1 12.6 10 5.9l2.9 6.7M8.35 10.9h3.3" fill="none" stroke="#fff"
    strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/>
    </symbol>
    <symbol id="ic-pts" viewBox="0 0 20 20">
    <path d="M10 2.4l2.28 4.72 5.12.72-3.72 3.6.9 5.16L10 14.14l-4.58 2.46.9-5.16L2.6 7.84l5.12-.72z"
    fill="var(--pts)"/>
    </symbol>

    <symbol id="i-home" viewBox="0 0 24 24"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20h14V9.5"/></symbol>
    <symbol id="i-br" viewBox="0 0 24 24"><rect x="4" y="3" width="12" height="18" rx="2"/><path d="M16 8h4v13H4"/><path d="M8 7h4M8 11h4M8 15h4"/></symbol>
    <symbol id="i-us" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.2"/><path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5"/><path d="M17 9.5 19 11.5 22.5 8"/></symbol>
    <symbol id="i-cal" viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="16" rx="2.5"/><path d="M8 3v4M16 3v4M3.5 10h17"/></symbol>
    <symbol id="i-crm" viewBox="0 0 24 24"><path d="M3 5h18l-7 8v6l-4 2v-8z"/></symbol>
    <symbol id="i-reg" viewBox="0 0 24 24"><rect x="5" y="3.5" width="14" height="17" rx="2.5"/><path d="M9 8h6M9 12h6M9 16h3"/></symbol>
    <symbol id="i-task" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="3"/><path d="M8.5 12l2.5 2.5 4.5-5"/></symbol>
    <symbol id="i-ch" viewBox="0 0 24 24"><path d="M5 20V11M12 20V4M19 20v-6"/></symbol>
    <symbol id="i-st" viewBox="0 0 24 24"><path d="M12 4l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4-3.9-3.8 5.4-.8z"/></symbol>
    <symbol id="i-bag" viewBox="0 0 24 24"><path d="M4 8h16l-1.2 12H5.2z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></symbol>
    <symbol id="i-gr" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M18.4 5.6l-1.8 1.8M7.4 16.6l-1.8 1.8"/></symbol>
    <symbol id="i-tm" viewBox="0 0 24 24"><circle cx="8" cy="9" r="2.6"/><circle cx="16" cy="9" r="2.6"/><path d="M3 19c0-2.8 2.2-4.6 5-4.6s5 1.8 5 4.6"/><path d="M11 19c0-2.8 2.2-4.6 5-4.6s5 1.8 5 4.6"/></symbol>
    <symbol id="i-dots" viewBox="0 0 24 24"><circle cx="5" cy="12" r="1.4"/><circle cx="12" cy="12" r="1.4"/><circle cx="19" cy="12" r="1.4"/></symbol>
    <symbol id="i-sl" viewBox="0 0 24 24"><path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></symbol>
    <symbol id="chev" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></symbol>
    <symbol id="left" viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></symbol>
    <symbol id="right" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></symbol>
    </svg>
  );
}
